(function () {
  var motionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motionQuery && motionQuery.matches) return;

  var root = document.documentElement;
  if (!root.classList.contains('product-detail-reveal-ready')) return;

  var main = document.getElementById('MainContent');
  var productSection = main && main.querySelector('.product-detail-section');
  if (!main || !productSection) {
    root.classList.remove('product-detail-reveal-ready');
    return;
  }

  function isElementVisible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isRenderableChild(element) {
    if (!isElementVisible(element)) return false;

    var tagName = element.tagName;
    if (!tagName) return false;

    return ['SCRIPT', 'STYLE', 'TEMPLATE', 'NOSCRIPT'].indexOf(tagName) === -1;
  }

  function isInitiallyVisible(element) {
    var rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.92;
  }

  function getChildren(target, type) {
    if (type === 'media') {
      return Array.prototype.slice.call(
        target.querySelectorAll('.product__media-item.is-active, .thumbnail-list__item')
      );
    }

    if (type === 'info') {
      return Array.prototype.slice.call(
        target.querySelectorAll('.product__info-container > *')
      );
    }

    if (type === 'summary') {
      return Array.prototype.slice.call(target.children);
    }

    return Array.prototype.slice.call(
      target.querySelectorAll([
        '.product__description > *',
        '.product-recommendations__heading',
        '.product-recommendations .grid__item',
        '.stamped-main-widget',
        '.spr-container',
        '.shopify-app-block',
        '.rte > *'
      ].join(','))
    );
  }

  function applyChildStagger(target, type) {
    var children = getChildren(target, type)
      .filter(isRenderableChild)
      .slice(0, 20);

    children.forEach(function (child, index) {
      var childType = child.classList.contains('thumbnail-list__item') ? 'thumbnail' : '';
      child.setAttribute('data-product-detail-reveal-child', childType);
      child.style.setProperty('--product-detail-reveal-child-delay', Math.min(index * 55, 440) + 'ms');
    });
  }

  function markTarget(element, type, delay) {
    if (!element) return null;

    if (!isElementVisible(element)) {
      if (element.hasAttribute('data-product-detail-reveal')) {
        element.classList.add('is-visible');
      }

      return null;
    }

    element.setAttribute('data-product-detail-reveal', type);
    element.style.setProperty('--product-detail-reveal-delay', delay + 'ms');
    applyChildStagger(element, type);

    return element;
  }

  function reveal(target, observer) {
    target.classList.add('is-visible');
    if (observer) observer.unobserve(target);
  }

  var productTargets = [
    markTarget(productSection.querySelector('.product-mobile-top-section'), 'summary', 0),
    markTarget(productSection.querySelector('.product__media-wrapper'), 'media', 60),
    markTarget(productSection.querySelector('.product__info-wrapper'), 'info', 130),
    markTarget(productSection.querySelector('.item-production-description'), 'section', 0)
  ].filter(Boolean);

  var sectionTargets = Array.prototype.slice.call(main.children)
    .filter(function (section) {
      return section.classList.contains('shopify-section') &&
        !section.querySelector('.product-detail-section') &&
        isElementVisible(section);
    })
    .map(function (section, index) {
      return markTarget(section, 'section', Math.min(index * 70, 280));
    })
    .filter(Boolean);

  var targets = productTargets.concat(sectionTargets);
  if (!targets.length) {
    root.classList.remove('product-detail-reveal-ready');
    return;
  }

  var initiallyVisibleTargets = targets.filter(isInitiallyVisible);

  root.classList.add('product-detail-reveal-ready');
  root.classList.add('product-detail-reveal-has-run');

  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      initiallyVisibleTargets.forEach(function (target, index) {
        window.setTimeout(function () {
          reveal(target);
        }, 90 + index * 110);
      });
    });
  });

  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (target) {
      reveal(target);
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        reveal(entry.target, observer);
      }
    });
  }, {
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.1
  });

  targets.forEach(function (target) {
    if (!target.classList.contains('is-visible') && initiallyVisibleTargets.indexOf(target) === -1) {
      observer.observe(target);
    }
  });

  if ('MutationObserver' in window) {
    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var target = mutation.target.closest && mutation.target.closest('[data-product-detail-reveal]');
        if (!target) return;

        applyChildStagger(target, target.getAttribute('data-product-detail-reveal'));
      });
    });

    targets.forEach(function (target) {
      mutationObserver.observe(target, { childList: true, subtree: true });
    });
  }
})();
